export const blockedUserModalType = "blocked-user-modal";
